import styled from '@emotion/styled'

import { mediaMax } from '@/styles/mixins'
import Button from '@/components/Button'

export const Container = styled.div`
  position:relative;
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 4rem;
  ${mediaMax.xs} {
    width: 90%;
  }
`

export const TextContainer = styled.div`
  width: 60%;
  display: flex;
  justify-content: center;

  ${mediaMax.md} {
    width: 75%;
  }
  ${mediaMax.xs} {
    width: 90%;
    justify-content: flex-start;
  }
`

export const Action = styled.div`
  width: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`
